import flatpickr from 'flatpickr/dist/flatpickr';
import Component from '../abstracts/Component';
import {IS_CHINA} from "../utils/Environment";
import { gregorian } from '@pacote/computus';

/**
 Date picker component
 */
export default class DatePickerComponent extends Component {

  get SELECTORS () {
    return {
      datepicker: '.js-datepicker',
      returnOrderProceed: '.js-proceed-to-confirm',
      dateOfBirth: '.js-dateofbirth'
    }
  }

  dateFormatByCountry() {
    // Korea: Y-M-D , US : M-D-Y, EU: D-M-Y
    let currentCountry = document.body.dataset.website;
    let dateFormat = '';

    switch(currentCountry) {
      case 'it':
        dateFormat= "d-m-Y";
        break;
      case 'us':
        dateFormat= "m-d-Y";
        break;
      case 'kr':
      case 'cn':
        dateFormat= "Y-m-d";
        break;
      default:
        dateFormat= "d-m-Y";
    }

    return dateFormat
  }



  today() {
    let todayTime = new Date();
    let dd = todayTime.getDate();
    let mm = todayTime.getMonth() + 1;
    let yyyy = todayTime.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }

    if (mm < 10) {
      mm = '0' + mm;
    }

    let format = this.dateFormatByCountry()
    let today = '';

    switch(format) {
      case 'd-m-Y':
        today =  dd + '/' + mm + '/' + yyyy;
        break;
      case 'm-d-Y':
        today =  mm + '/' + dd + '/' + yyyy;
        break;
      case 'Y-m-d':
        today =  yyyy + '/' + mm + '/' + dd;
        break;
      default:
        today =  dd + '/' + mm + '/' + yyyy;
    }

    return today
  }


  isAdultKr() {
    let date = new Date();
    let dd = date.getDate();
    let mm = date.getMonth() + 1; //January is 0!
    let yMax = date.getFullYear() - 18;
    let yMin = date.getFullYear() - 99;
    if(dd<10){dd='0'+dd}
    if(mm<10){mm='0'+mm}

    let validDateMin = yMin+'-'+mm+'-'+dd;
    let validDateMax = yMax+'-'+mm+'-'+dd;

    let validDate = {
      validDateMin: validDateMin,
      validDateMax: validDateMax
    }

    return validDate
  }


  initDatepicker(flatpickr,localization) {
    let ctx = this;
    let _dateFormat = ctx.dateFormatByCountry();
    // fallback
    if (typeof localization === 'undefined') {
      localization = this.getLocalization($('html').attr('lang'));
    }

    $(this.SELECTORS.datepicker).each(function () {
      let _this = $(this);
      let isStatic = false;
      let mindate = null;
      let maxdate = null;
      let defaultDate = Date.parse($(this).data('defaultDate'));
      let disableweekends = $(this).data('disableweekends') || false;
      let isKr = (document.body.dataset.website === 'kr');
      let isAdult = $(this).data('adultValidation')

      if((isKr || IS_CHINA) && $(this).data('adultValidation') === true ) {
        mindate = ctx.isAdultKr().validDateMin;
        maxdate = ctx.isAdultKr().validDateMax;
      } else if (!$(this).hasClass('js-dateofbirth')) {
        mindate = Date.parse($(this).data('mindate'));
        maxdate = Date.parse($(this).data('maxdate'));
      }

      if (disableweekends) {

        var isGLSOrder = document.getElementById("isGLSOrder");
        var country = $("body").data("website");
        var isCountryIT = country != null && country.toLowerCase() === 'it';
        if ((typeof(isGLSOrder) != 'undefined' && isGLSOrder != null && isGLSOrder.value === 'true') || isCountryIT) {
          var currentEasterDate = gregorian(new Date().getFullYear());
          var currentEasterMondayDate = new Date(currentEasterDate);
          currentEasterMondayDate.setDate(currentEasterDate.getDate() + 1);
          var currentEasterMonday = (currentEasterMondayDate.getDate()) + '/' + (currentEasterMondayDate.getMonth() + 1);
        }

        _this.flatpickr({
          static: isStatic ? isStatic : false,
          dateFormat: "Y-m-d",
          altInput: true,
          altFormat : _dateFormat,
          altInputClass: 'custom-date',
          minDate: mindate,
          maxDate: maxdate,
          disableMobile: true,
          allowInput: true,

          onChange: function (dateObj, dateStr, instance) {
            if ($('input[name=hourpick]').is(":checked")) {
              $(ctx.SELECTORS.returnOrderProceed).removeClass('disabled');
            }
          },
          animate: false,
          disable: [
            function(date) {
              var exclude = ["1/1", "6/1", "25/4", "1/5", "2/6", "15/8", "1/11", "8/12", "25/12", "26/12", currentEasterMonday];
              var d = date.getDate();
              var m = date.getMonth();
              var dayExclude = d + '/' + (m+1);
              return (date.getDay() === 6 || date.getDay() === 0 || ~$.inArray(dayExclude, exclude));
            }
          ],
          locale: localization
        });
      } else if ($(this).hasClass('js-dateofbirth')) {
        let originalInput = document.getElementById('param7');
        // no default on current date
        _this.flatpickr({
          static: false,
          disableMobile: 'true',
          dateFormat: "Y-m-d",
          altInput: true,
          altFormat: _dateFormat,
          altInputClass: 'custom-date',
          minDate: mindate,
          maxDate: maxdate,
          allowInput: true,
          locale: localization,
          onClose: function (dateObj, dateStr, instance) {
            document.dispatchEvent(new CustomEvent("flatpickrclose"));
          },
          onReady: function(selectedDates, dateStr, instance) {
            let altInput = instance.altInput;
            altInput.setAttribute('data-validation', originalInput.getAttribute('data-validation'));
            altInput.setAttribute('data-mindate', originalInput.getAttribute('data-mindate'));
            altInput.setAttribute('data-maxdate', originalInput.getAttribute('data-maxdate'));
            altInput.setAttribute('data-date-format', originalInput.getAttribute('data-date-format'));
            altInput.setAttribute('name', originalInput.getAttribute('name'));
            altInput.classList.add("js-dateofbirth");
          }
        });
      } else if (isKr) {
        _this.flatpickr({
          static: isStatic ? isStatic : false,
          disableMobile: "true",
          altInput: true,
          altFormat: "d/m/Y",
          disable: ["2019/08/28", "2019/09/03"],
          dateFormat: "Y/m/d",
          altInputClass: 'custom-date',
          minDate: mindate,
          maxDate: maxdate,
          allowInput: true,
          locale: localization
        });
      } else {
        _this.flatpickr({
          static: isStatic ? isStatic : false,
          disableMobile: "true",
          altInput: true,
          altFormat: _dateFormat,
          dateFormat: "Y/m/d",
          altInputClass: 'custom-date',
          minDate: mindate,
          maxDate: maxdate,
          allowInput: true,
          locale: localization
        });

      }

    });
  }

  constructor () {
    super();
  }


  getLocalization(lang)  {
    switch(lang) {
      case "en":
        return "default";
      case "en-US":
        return "default";
      default:
        return lang;
    }
  }

  render() {

    if ( document.querySelectorAll(this.SELECTORS.datepicker) || document.querySelector('#returnDate') || document.querySelector('.t-book-appointment')) {
      let lang = this.getLocalization($('html').attr('lang'))

      this.moduleLoader.loadFlatpickr(
          (module) => {
            this.moduleLoader.loadFlatpickrLocale(lang, (localization) => {
              this.flatpickr = module.default;
              this.localization = lang;
              this.initDatepicker(module.default, lang);
              this.bindEvents();
              this.setMaxLengthBirthDatePicker();
            },
            (err) => console.warn('cant load flatpickr')
            );
          })
    }else{
      document.querySelectorAll(this.SELECTORS.datepicker).forEach( (datepicker) => {
        if($(datepicker).data('adultValidation') === true ) {
          let maxMinDate = this.isAdultKr();
          datepicker.setAttribute("max", maxMinDate.validDateMax);
          datepicker.setAttribute("min", maxMinDate.validDateMin);
        }});
    }
    this.bindCustomEvents();
  }

  bindCustomEvents () {
    this.$on(this.$customEvents.PAGE_LAYOUT_EVENTS.initDatepicker, () => {
      if (!this.flatpickr) {
        this.loadFlatPickr();
      } else {
        this.initDatepicker();
      }
    });
  }

  bindEvents() {
    let isShift = false;
    const ctx = this;

    if ($(ctx.SELECTORS.dateOfBirth).length != 0) {
      $(ctx.SELECTORS.dateOfBirth)[1].onkeydown = function(e) {
        return ctx.isNumeric(this, e.key, isShift);
      }

      $(ctx.SELECTORS.dateOfBirth)[1].onkeyup = function(e) {
        ctx.validateDateFormat(this);
      }
    }
  }

  isNumeric(input, keyCode, isShift) {
    let acceptableKeys = ['0','1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'ArrowRight', 'ArrowLeft'];
    isShift = false;
    let seperator = '-'
    let isKr = (document.body.dataset.website === 'kr');

    let firstPart = isKr ? 4 : 2;
    let secondPart = isKr ? 7 : 5;

    if (keyCode == 'ShiftLeft'|| keyCode == 'ShiftRight') {
      isShift = true;
    }
    //Allow only numeric keys
    if (acceptableKeys.includes(keyCode) && isShift == false) {
      if ((input.value.length == firstPart || input.value.length == secondPart) && keyCode != 'Backspace') {
        input.value += seperator;
      }
      return true;
    }
    else {
      return false;
    }
  }

  validateDateFormat(input) {
    let dateString = input.value;
    let _dateFormat = this.dateFormatByCountry();
    let isKr = (document.body.dataset.website === 'kr');

    let regex = isKr ? /^\d{4}[-]\d{2}[-]\d{2}$/ : /^\d{2}[-]\d{2}[-]\d{4}$/;

    //Check whether valid date format for manual insert.
    if (regex.test(dateString)) {
      //Parsing user manual insert
      let date = flatpickr.parseDate(dateString, _dateFormat);

      //Set date value
      $(this.SELECTORS.datepicker)[0]._flatpickr.setDate(date);
    }
  }

  setMaxLengthBirthDatePicker() {
    $(this.SELECTORS.dateOfBirth).attr('maxlength', '10');
  }
}
